
import { setPageHeader } from '@/core/helpers/toolbar';
import { defineComponent, ref, watchEffect } from 'vue';
import PromotionList from '../components/PromotionList.vue';
import PromotionForm from '../components/PromotionForm.vue';

export default defineComponent({
    name: 'promotions',
    components: {
        PromotionList,
        PromotionForm
    },
    setup() {
        const tabsValue = ref(0);
        const serviceTab = ref(true);
        const promotionType = ref('SERVICE');

        const pageHeader = (title: string) => {
            setPageHeader({
                title,
                actionButton: {
                    ability: 'view_setting',
                    pageAction: {
                        action: 'addPromotionAction'
                    },
                    button: {
                        title: 'message.ADD message.PROMOTION',
                        icon: 'bi bi-plus',
                        openModal: true
                    }
                },
                breadCrumbs: [
                    { name: 'message.HOME', link: '/dashboard' },
                    { name: 'message.SYSTEM', link: '#' },
                    { name: 'message.SETTINGS', link: '/system/settings' },
                    { name: title }
                ]
            });
        };

        watchEffect(() => {
            // Product promotion tab is hidden. This page is push notifications only.
            serviceTab.value = true;
            promotionType.value = 'SERVICE';
            pageHeader('message.SERVICE_PROMOTION');
        });

        return {
            tabsValue,
            serviceTab,
            promotionType
        };
    }
});
